/* eslint-disable @typescript-eslint/strict-boolean-expressions */

import _ from 'lodash';
import React, {useState} from 'react';
import {Button} from 'react-bootstrap';
interface UploadedFile {
  image: File;
  preview: string;
  type: 'image' | 'video';
  sort_order: number;
  croppedPreview?: string; // Added for storing cropped image preview
  fileName?: string;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
interface Images {
  id?: string;
  name?: string;
  sort_order: number;
}

interface FileUploaderProps {
  onFilesAdded: (files: UploadedFile[]) => void;
  accept: Record<string, string[]>;
  multiple?: boolean;
  images: Array<{id: string; name: string; sort_order: number}>;
}

const FileUploader: React.FC<FileUploaderProps> = ({
  onFilesAdded,
  accept,
  multiple = true,
  images = [],
}) => {
  const [files, setFiles] = useState<any[]>([...images]);
  const [tempfiles, setTempFiles] = useState<any[]>([...images]);

  // console.log('🚀 ~ files in file uploader:', files);
  const [draggedIndex, setDraggedIndex] = useState<number | null>(null);
  const [error, setError] = useState<string | null>(null);
  const allowedTypes = [
    'image/jpeg',
    'image/png',
    'image/jpg',
    'video/mp4',
    'video/webm',
    'video/ogg',
  ];

  const [selectedFile, setSelectedFile] = useState<UploadedFile | null>(null);
  console.log('🚀 ~ selectedFile:', selectedFile);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [imageDimensions, setImageDimensions] = useState({width: 0, height: 0}); // Image dimensions

  // const handleDrop = (acceptedFiles: File[]): void => {
  //   if (!acceptedFiles.length) return;

  //   const maxSize = 10; // 10MB limit
  //   const maxSizeInBytes = maxSize * 1024 * 1024;
  //   const maxWidth = 1080; // Max width allowed
  //   const maxHeight = 1080; // Max height allowed
  //   const mappedFiles: UploadedFile[] = [];
  //   let sizeError = false;
  //   let resolutionError = false;

  //   acceptedFiles.forEach((file: File, index: number) => {
  //     if (!allowedTypes.includes(file?.type)) return; // Skip unsupported file types

  //     if (file.size > maxSizeInBytes) {
  //       setError(`File "${file.name}" exceeds the ${maxSize} MB limit.`);
  //       sizeError = true;
  //       return;
  //     }

  //     const fileType = file.type.startsWith('image') ? 'image' : 'video';
  //     const filePreview = URL.createObjectURL(file);

  //     if (fileType === 'image') {
  //       // ✅ Validate image resolution
  //       const img = new Image();
  //       img.onload = () => {
  //         if (img.width > maxWidth || img.height > maxHeight) {
  //           setError(
  //             `Image "${file.name}" exceeds ${maxWidth}x${maxHeight} resolution.`,
  //           );
  //           resolutionError = true;
  //           return;
  //         }

  //         mappedFiles.push({
  //           image: file,
  //           preview: filePreview,
  //           type: 'image',
  //           sort_order: tempfiles.length + mappedFiles.length + 1,
  //           croppedPreview: filePreview,
  //           fileName: file.name,
  //         });

  //         updateFiles(mappedFiles);
  //       };
  //       img.src = filePreview;
  //     } else {
  //       // ✅ Validate video resolution
  //       const video = document.createElement('video');
  //       video.preload = 'metadata';
  //       video.src = filePreview;

  //       video.onloadedmetadata = () => {
  //         if (video.videoWidth > maxWidth || video.videoHeight > maxHeight) {
  //           setError(
  //             `Video "${file.name}" exceeds ${maxWidth}x${maxHeight} resolution.`,
  //           );
  //           resolutionError = true;
  //           return;
  //         }

  //         mappedFiles.push({
  //           image: file,
  //           preview: filePreview,
  //           type: 'video',
  //           sort_order: tempfiles.length + mappedFiles.length + 1,
  //           fileName: file.name,
  //         });

  //         updateFiles(mappedFiles);
  //       };
  //     }
  //   });

  //   if (sizeError || resolutionError) return;

  //   // ✅ Function to update files in state
  //   // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  //   const updateFiles = (newFiles: UploadedFile[]) => {
  //     const updatedFiles = [...files, ...newFiles];
  //     setTempFiles(updatedFiles);
  //     setFiles(updatedFiles);

  //     if (onFilesAdded) {
  //       onFilesAdded(updatedFiles);
  //     }
  //     setError(null); // Clear errors if successful
  //   };
  // };

  const handleDrop = (acceptedFiles: File[]): void => {
    if (!acceptedFiles.length) return;

    setError(null); // Reset error when a new file is uploaded

    const maxSize = 10; // 10MB limit
    const maxSizeInBytes = maxSize * 1024 * 1024;
    const maxWidth = 1080; // Max width allowed
    const maxHeight = 1080; // Max height allowed
    const mappedFiles: UploadedFile[] = [];

    let hasError = false;

    const processFile = (
      file: File,
      filePreview: string,
      type: 'image' | 'video',
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    ) => {
      mappedFiles.push({
        image: file,
        preview: filePreview,
        type,
        sort_order: tempfiles.length + mappedFiles.length + 1,
        fileName: file.name,
        ...(type === 'image' && {croppedPreview: filePreview}),
      });

      if (!hasError) {
        updateFiles(mappedFiles);
      }
    };

    acceptedFiles.forEach((file: File) => {
      if (!allowedTypes.includes(file.type)) return;

      if (file.size > maxSizeInBytes) {
        setError(`File "${file.name}" exceeds the ${maxSize} MB limit.`);
        hasError = true;
        return;
      }

      const fileType = file.type.startsWith('image') ? 'image' : 'video';
      const filePreview = URL.createObjectURL(file);

      if (fileType === 'image') {
        const img = new Image();
        img.onload = () => {
          if (img.width > maxWidth || img.height > maxHeight) {
            setError(
              `Image "${file.name}" exceeds ${maxWidth}x${maxHeight} resolution.`,
            );
            hasError = true;
          } else {
            processFile(file, filePreview, 'image');
          }
        };
        img.src = filePreview;
      } else {
        const video = document.createElement('video');
        video.preload = 'metadata';
        video.src = filePreview;
        video.onloadedmetadata = () => {
          if (video.videoWidth > maxWidth || video.videoHeight > maxHeight) {
            setError(
              `Video "${file.name}" exceeds ${maxWidth}x${maxHeight} resolution.`,
            );
            hasError = true;
          } else {
            processFile(file, filePreview, 'video');
          }
        };
      }
    });

    // Function to update files in state
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    const updateFiles = (newFiles: UploadedFile[]) => {
      const updatedFiles = [...files, ...newFiles];
      setTempFiles(updatedFiles);
      setFiles(updatedFiles);

      if (onFilesAdded) {
        onFilesAdded(updatedFiles);
      }
    };
  };

  const handleRemove = (index: number, id: any = undefined): void => {
    const fileToRemove = files[index];

    if (fileToRemove.id) {
      const updatedFiles = files.map((file, i) =>
        file?.id === id
          ? _.omit({...file, type: 'delete'}, [
              'event_id',
              'name',
              'image_name',
              'sort_order',
            ])
          : file,
      );

      setFiles(updatedFiles); // Update the state with the modified files
      setTempFiles(updatedFiles);

      if (onFilesAdded) {
        onFilesAdded(updatedFiles);
      }

      if (updatedFiles.length <= 4) {
        setError(null);
      }
    } else {
      const updatedFiles = files.filter((_, i) => i !== index);
      setFiles(updatedFiles);
      setTempFiles(updatedFiles);
      if (onFilesAdded) {
        onFilesAdded(updatedFiles);
      }
      // const updateSelectedFile = files.filter((_, i) => i !== selectedFile?.sort_order);

      if (updatedFiles.length <= 4) {
        setError(null);
      }
    }
  };

  // Drag Start handler
  const handleDragStart = (index: number): void => {
    setDraggedIndex(index);
  };

  // Drag Over handler
  const handleDragOver = (e: React.DragEvent): void => {
    e.preventDefault();
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleFileValidation = (files: File[]): void => {
    const invalidFiles = files.filter(
      file => !allowedTypes.includes(file.type),
    );

    if (invalidFiles.length > 0) {
      alert(
        'Only image and video files are allowed.Please upload an image of type: jpeg, png, jpg,webp and video of type: mp4, webm.',
      );
      // Prevent adding invalid files
    }
  };

  // Drop handler with sort order update
  const handleDropItem = (index: number): void => {
    if (draggedIndex === null) return;

    const updatedFiles = [...files];
    const [draggedItem] = updatedFiles.splice(draggedIndex, 1);
    updatedFiles.splice(index, 0, draggedItem);

    // Update sort_order based on new positions
    const reorderedFiles = updatedFiles.map((file, idx) => ({
      ...file,
      sort_order: idx + 1, // Assign a new sort order
    }));

    console.log('🚀 ~ handleDropItem ~ reorderedFiles:', reorderedFiles);

    setFiles(reorderedFiles);
    setTempFiles(reorderedFiles);
    setDraggedIndex(null); // Reset dragged index after drop
    onFilesAdded(reorderedFiles);
  };

  // Handle drop event
  const handleDropEvent = (e: any): void => {
    e.preventDefault(); // Prevent the default behavior (opening the file)
    e.stopPropagation(); // Stop the event from propagating

    const files = e.dataTransfer.files;
    if (files.length > 0) {
      handleDrop(Array.from(files)); // Pass the dropped files to the handleDrop function
    }
  };

  return (
    <div>
      <div
        style={{
          border: '2px dashed #888',
          padding: '20px',
          textAlign: 'center',
          cursor: 'pointer',
          width: '100%',
          minWidth: '400px',
        }}
        onClick={() => document.getElementById('file-input')?.click()}
        onDragOver={handleDragOver} // Handle drag over
        onDrop={handleDropEvent} // Handle drop
      >
        <input
          id="file-input"
          type="file"
          name="file"
          multiple={multiple}
          accept={Object.keys(accept).join(',')}
          onChange={(e): void => {
            if (e.target.files) {
              handleDrop(Array.from(e.target.files));
              handleFileValidation(Array.from(e.target.files));
            }
            e.target.value = ''; // 👈 allows same file to be selected again
          }}
          style={{display: 'none'}}
        />
        <p>Drag & Drop files here, or click to select</p>
      </div>

      {files.length > 0 && (
        <div
          style={{
            marginTop: '20px',
            display: 'flex',
            flexDirection: 'column',
            gap: '10px',
          }}>
          {files
            .filter(file => file.type !== 'delete') // Exclude files with type 'delete'
            .sort((a, b) => {
              // Sort by sort_order, if available
              if (a.sort_order && b.sort_order) {
                return a.sort_order - b.sort_order; // Ascending order
              }
              return 0; // Keep the same order if sort_order is missing
            })
            .map((file, index) => (
              <div
                key={file?.file?.name}
                draggable
                onDragStart={() => {
                  handleDragStart(index);
                }}
                onDragOver={handleDragOver}
                onDrop={() => {
                  handleDropItem(index);
                }}
                style={{
                  border: '1px solid #ccc',
                  padding: '10px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px',
                  boxSizing: 'border-box',
                  cursor: 'move',
                  // Apply different styles when the item is being dragged
                  backgroundColor:
                    draggedIndex === index ? '#e1f7d5' : 'transparent',
                  opacity: draggedIndex === index ? 0.5 : 1,
                }}>
                {file.id ? (
                  <>
                    {(() => {
                      const fileName = file?.name || '';
                      const isImage =
                        /\.(jpg|jpeg|png|gif|bmp|svg|webp)$/i.test(fileName);
                      const isVideo = /\.(mp4|webm|ogg|mov|avi|flv|mkv)$/i.test(
                        fileName,
                      );
                      if (isImage) {
                        return (
                          <img
                            src={fileName}
                            alt={file?.image_name || 'Image'}
                            style={{
                              width: '50px',
                              height: '50px',
                              objectFit: 'cover',
                              borderRadius: '5px',
                            }}
                          />
                        );
                      } else if (isVideo) {
                        return (
                          <video
                            src={fileName}
                            controls
                            style={{
                              width: '50px',
                              height: '50px',
                              objectFit: 'cover',
                              borderRadius: '5px',
                            }}
                          />
                        );
                      } else {
                        return <span>Unsupported file format</span>;
                      }
                    })()}

                    <p style={{flexGrow: 1, margin: 0}}>{file?.image_name}</p>
                  </>
                ) : (
                  <>
                    {file.type === 'image' ? (
                      <>
                        <img
                          src={file.croppedPreview || file.preview}
                          // alt={file.file.name}
                          style={{
                            width: '50px',
                            height: '50px',
                            objectFit: 'cover',
                          }}
                          onClick={() => {
                            setSelectedFile(file);
                          }} // Select file for cropping
                        />
                        <p style={{flexGrow: 1, margin: 0}}>
                          {file?.image.name}
                        </p>
                      </>
                    ) : (
                      <>
                        <video
                          src={file.croppedPreview || file.preview}
                          controls
                          style={{
                            width: '50px',
                            height: '50px',
                            objectFit: 'cover',
                          }}
                        />
                        <p
                          style={{flexGrow: 1, margin: 0}}
                          onClick={e => {
                            e.stopPropagation(); // Prevent other click handlers from interfering
                            console.log('video clicked', file);
                            setSelectedFile(file);
                          }}>
                          {file?.image.name}
                        </p>
                      </>
                    )}
                  </>
                )}

                <Button
                  type="button"
                  role="remove"
                  className="btn btn-danger btn-icon ms-auto"
                  onClick={() => {
                    handleRemove(index, file.id);
                  }}>
                  <i className="ri-delete-bin-5-line"></i>
                </Button>
              </div>
              // ) : null,
            ))}
        </div>
      )}
      {error && <div style={{color: 'red'}}>{error}</div>}
    </div>
  );
};

export default FileUploader;
